module.exports = __webpack_public_path__ + "img/ribbon_pink.15f7bae3.png";